export class GroupResponse {
  /**
   * @param {Object} response
   * @param {String} response.id
   * @param {String} response.name
   * @param {ฺBoolean} response.is_affect_app
   * @param {DateTime | null} response.deleted_at
   */
  constructor(response) {
    this.id = response.id;
    this.name = response.name;
    this.is_affect_app = response.is_affect_app;
    this.deleted_at = response.deleted_at;
  }
}